import { HistoryRecord } from '@/types/redirect'
import { historyAtom } from '@/utils/global-states'
import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function NavigationEvents() {
	const location = useLocation()
	const setHistory = useSetAtom(historyAtom)

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search)
		// const url = `${location.pathname}?${searchParams}`
		// console.log(url)
		const current = {
			path: location.pathname,
			params: searchParams.toString(),
		} as HistoryRecord

		if (!location.pathname.startsWith('/auth')) {
			setHistory(prev => {
				if (prev.length > 0) {
					if (prev[0].path !== current.path) {
						return [current, ...prev]
					} else {
						prev[0] = current
						return prev
					}
				}
				return [current]
			})
		}
	}, [location.pathname, location.search, setHistory])

	return null
}
